import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-video-line',
    title: '海量教学视频',
    desc: '涵盖小学至考研全阶段，高考冲刺、考研政英数、托福雅思、会计考试等专业课程应有尽有。',
    color: 'bg-red-50',
    iconColor: 'text-red-600',
    link: '/videos',
  },
  {
    icon: 'ri-team-line',
    title: '学生互助交流',
    desc: '城市与农村学生跨越地域界限，加好友、组学习小组，共同进步，打破教育资源壁垒。',
    color: 'bg-amber-50',
    iconColor: 'text-amber-600',
    link: '/community',
  },
  {
    icon: 'ri-user-star-line',
    title: '师生互动答疑',
    desc: '优秀教师在线答疑，学生随时提问，老师实时解答，让学习不再有疑惑。',
    color: 'bg-green-50',
    iconColor: 'text-green-600',
    link: '/community/teacher',
  },
  {
    icon: 'ri-parent-line',
    title: '家长助力找伴',
    desc: '家长可以帮助孩子找到同年级的学习伙伴，让孩子在互助中共同成长。',
    color: 'bg-blue-50',
    iconColor: 'text-blue-600',
    link: '/community/parent',
  },
  {
    icon: 'ri-store-2-line',
    title: '学习用品商城',
    desc: '精选文具、教辅书籍、儿童服装、学习设备，一站式满足学习生活所需。',
    color: 'bg-purple-50',
    iconColor: 'text-purple-600',
    link: '/shop',
  },
  {
    icon: 'ri-trophy-line',
    title: '高考考研专区',
    desc: '专注高考与考研核心备考，名师押题、真题解析、冲刺课程，助你金榜题名！',
    color: 'bg-orange-50',
    iconColor: 'text-orange-600',
    link: '/videos',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 border border-gray-200 rounded-full px-4 py-1.5 mb-4">
            <span className="text-gray-500 text-sm">平台核心功能</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4">
            一个平台，满足所有
            <span className="text-red-600">升学需求</span>
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            金榜旺财整合教学视频、社交交流、师生互动、商品购买于一体，是您升学路上最可靠的伙伴。
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => (
            <Link
              key={f.title}
              to={f.link}
              className={`${f.color} rounded-2xl p-7 group hover:scale-[1.02] transition-all cursor-pointer block`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl bg-white mb-5 shadow-sm`}>
                <i className={`${f.icon} text-2xl ${f.iconColor}`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-red-600 transition-colors">{f.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{f.desc}</p>
              <div className="flex items-center gap-1 mt-4 text-sm font-medium text-gray-400 group-hover:text-red-600 transition-colors">
                <span>了解更多</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
